import { MotifButton, MotifIcon } from "@ey-xd/motif-react";
import { IconoirPlus } from "@ey-xd/motif-icon";
import { useState } from "react";
import { useGetPayeeTypeSummaryApiDataQuery } from "./calculationStepReducer";
import FormModalResultSetting from "./FormModal/FormModalResultSetting";
import { useTranslation } from "react-i18next";
import { havingEditPermission } from "@/utility/common";
import { EDIT_BUTTON_VARIANT } from "@/components/Images/CommonImages";

export const ResultSetting = ({
  caseId,
  stepId,
  distributionStatus,
  CalculationSettings,
}: any) => {
  const [createShow, setCreateShow] = useState(false);
  const { t } = useTranslation();
  const [resultSetData, setResultSetData] = useState({});
  const [editId, setEditId] = useState("");
  const { data: payeeTypeSummary, refetch } =
    useGetPayeeTypeSummaryApiDataQuery(stepId);
  return (
    <>
      <div className="motif-container case-summary-form pad-v-20 mar-t-20">
        <div className="display-flex justify-content-between align-items-center">
          <div>
            <div className="motif-body1-default-regular page-title">
              {t(
                "pages.distributions.distributionStepsTab.resultSettingTab.title"
              )}
            </div>
            <div className="motif-body2-default-regular page-description">
              {t(
                "pages.distributions.distributionStepsTab.resultSettingTab.description"
              )}
            </div>
          </div>
          {havingEditPermission(CalculationSettings || []) && (
            <div>
              {payeeTypeSummary?.calculationStepId !== "" ? (
                <MotifButton
                  onClick={() => {
                    setCreateShow(true);
                    setEditId(payeeTypeSummary?.calculationStepId);
                    setResultSetData(payeeTypeSummary);
                  }}
                  size="small"
                  type="submit"
                  variant={EDIT_BUTTON_VARIANT}
                  disabled={distributionStatus}
                >
                  {t("global.globalActions.edit")}
                </MotifButton>
              ) : (
                <MotifButton
                  onClick={() => {
                    setCreateShow(true);
                  }}
                  size="small"
                  type="submit"
                  variant={EDIT_BUTTON_VARIANT}
                >
                  <MotifIcon iconFunction={IconoirPlus} />
                </MotifButton>
              )}
            </div>
          )}
        </div>
      </div>
      <div
        className={` mar-b-80 ${
          createShow ? "ccwp_createshow_wrapper" : "ccwp_createhide_wrapper"
        }
        `}
      >
        {createShow ? (
          <FormModalResultSetting
            createShow={createShow}
            setCreateShow={setCreateShow}
            caseId={caseId}
            stepId={stepId}
            refetch={refetch}
            editId={editId}
            payeeTypeSummary={resultSetData}
          />
        ) : (
          <>
            <div className="motif-row ">
              <div className="motif-col-lg-4">
                <div>
                  <div className="title">
                    {t(
                      "pages.distributions.distributionStepsTab.resultSettingTab.formLabels.rounding"
                    )}
                  </div>
                  <div className="motif-body2-default-bold">
                    {payeeTypeSummary?.rounding === 0
                      ? t(
                          "pages.distributions.distributionStepsTab.resultSettingTab.roundingOptions.label1"
                        )
                      : payeeTypeSummary?.rounding === 1
                      ? t(
                          "pages.distributions.distributionStepsTab.resultSettingTab.roundingOptions.label2"
                        )
                      : payeeTypeSummary?.rounding === 2
                      ? t(
                          "pages.distributions.distributionStepsTab.resultSettingTab.roundingOptions.label3"
                        )
                      : payeeTypeSummary?.rounding === -1 ||
                        payeeTypeSummary?.rounding === null
                      ? t(
                          "pages.distributions.distributionStepsTab.resultSettingTab.roundingOptions.label4"
                        )
                      : "-"}
                  </div>
                </div>
              </div>
              {payeeTypeSummary?.rounding !== -1 &&
                payeeTypeSummary?.rounding !== null && (
                  <div className="motif-col-lg-4">
                    <div>
                      <div className="title">
                        {t(
                          "pages.distributions.distributionStepsTab.resultSettingTab.formLabels.multipleIssue"
                        )}
                      </div>
                      <div className="motif-body2-default-bold">
                        {payeeTypeSummary?.denomination !== null
                          ? payeeTypeSummary?.denomination
                          : "-"}
                      </div>
                    </div>
                  </div>
                )}
              <div className="motif-col-lg-4">
                <div>
                  <div className="title">
                    {t(
                      "pages.distributions.distributionStepsTab.resultSettingTab.formLabels.minimumIssueAmount"
                    )}
                  </div>
                  <div className="motif-body2-default-bold">
                    {payeeTypeSummary?.minimumIssueAmount ||
                    payeeTypeSummary?.minimumIssueAmount === 0
                      ? Number(payeeTypeSummary?.minimumIssueAmount)
                      : "-"}
                  </div>
                </div>
              </div>
              {/* <div className="motif-col-lg-4 mar-t-20">
                <div>
                  <div className="title">Payee Type</div>
                  <div className="motif-body2-default-bold">
                    {payeeTypeSummary?.payeeType
                      ? payeeTypeSummary?.payeeType
                      : "-"}
                  </div>
                </div>
              </div> */}
              {/* <div className="motif-col-lg-4 mar-t-20">
                <div>
                  <div className="title">Payment grouping</div>
                  <div className="motif-body2-default-bold">
                    {payeeTypeSummary?.paymentGrouping === 0
                      ? "Split by Creditor"
                      : payeeTypeSummary?.paymentGrouping === 1
                      ? "Split by Payee"
                      : payeeTypeSummary?.paymentGrouping === 2
                      ? "Claim Owner"
                      : "-"}
                  </div>
                </div>
              </div> */}
            </div>
          </>
        )}
      </div>
    </>
  );
};
